import type { AbstractControl, ValidationErrors } from '@angular/forms';
import { ADDRESS_VALIDATION_ERROR_KEYS } from './address-field.validators';

/** Maximum length for entry/buzzer code fields. */
export const ENTRY_BUZZER_CODE_MAX_LENGTH = 6;

/** Allows letters and numbers only (numeric and permitted free-form alphanumeric values). */
export const ENTRY_BUZZER_CODE_REGEX = /^[A-Za-z0-9]*$/;

/**
 * Returns whether the value is blank or contains only alphanumeric characters.
 */
export function isValidEntryBuzzerCode(value: string): boolean {
  return ENTRY_BUZZER_CODE_REGEX.test(value);
}

/**
 * Validates optional entry/buzzer codes when a non-blank value is present.
 */
export function optionalEntryBuzzerCodeValidator(
  control: AbstractControl,
): ValidationErrors | null {
  const value = typeof control.value === 'string' ? control.value.trim() : '';

  if (!value) {
    return null;
  }

  return isValidEntryBuzzerCode(value)
    ? null
    : { [ADDRESS_VALIDATION_ERROR_KEYS.entryBuzzerCodeInvalid]: true };
}
